module.exports = __webpack_public_path__ + "img/pexels-pixabay-271667.bf1fc42f.jpg";